<template>
  <div id="preview" class="ngb-edit-wrap">
    <v-card class="form-card elevation-6 rounded-lg">
      <!-- Modern Professional Header -->
      <v-sheet class="modify-header" tile>
        <div class="header-wrapper">
          <!-- Left Section: Title with Icon -->
          <div class="header-left-section">
            <div class="icon-wrapper">
              <v-icon x-large color="white" class="header-icon"
                >mdi-account-edit</v-icon
              >
            </div>
            <div class="header-text">
              <h2 class="header-title">{{ pageDescription }}</h2>
              <p class="header-subtitle">
                <v-icon x-small class="mr-1">mdi-calendar-check</v-icon>
                {{ YearName }}
              </p>
            </div>
          </div>

          <!-- Right Section: Actions -->
          <div class="header-right-section">
            <v-chip
              small
              color="rgba(255, 255, 255, 0.25)"
              text-color="white"
              class="year-badge"
            >
              <v-icon left x-small>mdi-calendar</v-icon>
              {{ YearName }}
            </v-chip>

            <v-btn
              icon
              small
              color="white"
              class="icon-action-btn"
              @click.prevent="refreshPageData"
              :loading="LoadingFlag"
              v-tooltip="'Refresh Data'"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>

            <v-btn
              icon
              small
              color="white"
              class="icon-action-btn"
              @click="closePrompt"
              v-tooltip="'Close Dialog'"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-sheet>

      <v-form ref="form1" v-model="valid1" lazy-validation>
        <v-card-text>
          <v-container fluid>
            <!-- Selection Section -->
            <v-row dense class="mb-4">
              <v-col cols="12">
                <h3 class="section-title">
                  <v-icon small class="mr-2">mdi-playlist-check</v-icon>
                  Member Update
                </h3>
              </v-col>

              <v-col cols="12" md="4">
                <label class="field-label">
                  <v-icon x-small class="mr-1">mdi-briefcase</v-icon>
                  Designation
                </label>
                <v-text-field
                  v-model="DesignationName"
                  dense
                  outlined
                  disabled
                  class="control-input"
                  prepend-inner-icon="mdi-briefcase"
                />
              </v-col>

              <v-col cols="12" md="4">
                <label class="field-label">
                  <v-icon x-small class="mr-1 text-error">mdi-asterisk</v-icon>
                  <v-icon x-small class="mr-1">mdi-map-marker</v-icon>
                  Zone
                </label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="ZoneCodeOptionsLoading"
                  :items="ZoneCodeOptions"
                  :rules="ZoneCodeRules"
                  v-model="ZoneCode"
                  required
                  outlined
                  dense
                  clearable
                  class="control-input"
                  prepend-inner-icon="mdi-map-marker"
                />
              </v-col>

              <v-col cols="12" md="4">
                <label class="field-label">
                  <v-icon x-small class="mr-1 text-error">mdi-asterisk</v-icon>
                  <v-icon x-small class="mr-1">mdi-home-city</v-icon>
                  LOM
                </label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="LomCodeOptionsLoading"
                  :items="LomCodeOptions"
                  :rules="LomCodeRules"
                  v-model="LomCode"
                  required
                  outlined
                  dense
                  clearable
                  class="control-input"
                  prepend-inner-icon="mdi-home-city"
                />
              </v-col>

              <v-col cols="12" md="4">
                <label class="field-label">
                  <v-icon x-small class="mr-1 text-error">mdi-asterisk</v-icon>
                  <v-icon x-small class="mr-1">mdi-account</v-icon>
                  Member
                </label>
                <v-autocomplete
                  @change="getMemberDetails"
                  :reduce="(option) => option.value"
                  :loading="MemberIdOptionsLoading"
                  :items="MemberIdOptions"
                  :rules="MemberIdRules"
                  v-model="MemberId"
                  required
                  outlined
                  dense
                  clearable
                  class="control-input"
                  prepend-inner-icon="mdi-account-search"
                >
                  <template v-slot:selection="{ item }">
                    <img
                      width="30"
                      height="30"
                      :src="item.photo"
                      class="mr-2"
                    />
                    {{ item.text }}
                  </template>
                  <template v-slot:item="{ item }">
                    <img
                      width="40"
                      height="40"
                      :src="item.photo"
                      class="mr-2"
                    />
                    {{ item.text }}
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <!-- Member Details Card -->
            <v-row
              v-if="Object.keys(member).length > 0 && member.MemberId"
              class="mt-4"
            >
              <v-col cols="12">
                <v-card class="member-details-card elevation-3 rounded-lg">
                  <v-card-title class="details-card-header">
                    <v-icon color="white" class="mr-2"
                      >mdi-account-details</v-icon
                    >
                    <span>Member Details & Status</span>
                  </v-card-title>

                  <v-card-text class="pa-4">
                    <!-- Compact Status Row - ZGB Style -->
                    <v-row dense align="center" class="status-row-compact">
                      <!-- Date of Birth -->
                      <v-col cols="12" sm="6" md="2" class="status-item">
                        <div class="status-label-compact">
                          <v-icon x-small class="mr-1">mdi-calendar</v-icon>
                          Date of Birth
                        </div>
                        <v-menu
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="member.member_dob"
                              :rules="DobRules"
                              readonly
                              v-on="on"
                              dense
                              outlined
                              class="control-input-compact"
                              prepend-inner-icon="mdi-calendar"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="member.member_dob"
                            @input="menu1 = false"
                          ></v-date-picker>
                        </v-menu>
                        <div class="mt-1" v-if="member.member_dob">
                          <v-chip
                            x-small
                            :color="member.AadhaarNo ? 'success' : 'warning'"
                            text-color="white"
                            class="verification-chip"
                          >
                            <v-icon left x-small>{{
                              member.AadhaarNo
                                ? "mdi-check-circle"
                                : "mdi-alert-circle"
                            }}</v-icon>
                            {{
                              member.AadhaarNo
                                ? "DOB verified by Aadhaar"
                                : "DOB not verified by Aadhaar"
                            }}
                          </v-chip>
                        </div>
                      </v-col>

                      <!-- Profile Verification -->
                      <v-col cols="12" sm="6" md="2" class="status-item">
                        <div class="status-label-compact">
                          <v-icon x-small class="mr-1">mdi-account-box</v-icon>
                          Profile Verification
                        </div>
                        <div class="d-flex align-center gap-1">
                          <v-chip
                            :color="member.ProfileVerifiedTxtColor"
                            label
                            class="status-chip text-white"
                          >
                            <v-icon left small color="white">
                              {{
                                member.ProfileStatus
                                  ? "mdi-check-circle"
                                  : "mdi-clock-outline"
                              }}
                            </v-icon>
                            {{ member.ProfileVerifiedTxt }}
                          </v-chip>
                        </div>
                        <br />
                        <div
                          v-if="member.MissingSteps"
                          class="pa-3 rounded-lg text-center"
                          style="
                            background-color: #fff3cd;
                            color: #856404;
                            border: 1px solid #ffeeba;
                          "
                        >
                          <strong>⚠️ Missing Steps:</strong>
                          {{ member.MissingSteps }}
                        </div>
                      </v-col>

                      <!-- Photo Update -->
                      <v-col cols="12" sm="6" md="2" class="status-item">
                        <div class="status-label-compact">
                          <v-icon x-small class="mr-1">mdi-image</v-icon>
                          Photo Update
                        </div>
                        <div class="d-flex align-center gap-1">
                          <v-chip
                            :color="member.photo_flag ? 'success' : 'warning'"
                            label
                            class="status-chip mr-2"
                          >
                            <v-icon left small>{{
                              member.photo_flag
                                ? "mdi-check-circle"
                                : "mdi-clock-outline"
                            }}</v-icon>
                            {{ member.photo_flag ? "Completed" : "Pending" }}
                          </v-chip>
                        </div>
                      </v-col>

                      <!-- Age Proof Document -->
                      <v-col cols="12" sm="6" md="2" class="status-item">
                        <div class="status-label-compact">
                          <v-icon x-small class="mr-1"
                            >mdi-file-certificate</v-icon
                          >
                          Age Proof
                        </div>
                        <div class="d-flex align-center gap-1">
                          <v-chip
                            :color="
                              member.document_flag ? 'success' : 'warning'
                            "
                            label
                            class="status-chip mr-2"
                          >
                            <v-icon left small>{{
                              member.document_flag
                                ? "mdi-check-circle"
                                : "mdi-clock-outline"
                            }}</v-icon>
                            {{ member.document_flag ? "Completed" : "Pending" }}
                          </v-chip>
                        </div>
                      </v-col>

                      <!-- Aadhaar Status -->
                      <v-col cols="12" sm="6" md="2" class="status-item">
                        <div class="status-label-compact">
                          <v-icon x-small class="mr-1"
                            >mdi-card-account-details</v-icon
                          >
                          Aadhaar Status
                        </div>
                        <div class="d-flex align-center">
                          <v-chip
                            :color="member.AadhaarTextColor"
                            label
                            class="status-chip text-white"
                          >
                            <v-icon left small>{{
                              member.AadhaarNo
                                ? "mdi-check-circle"
                                : "mdi-alert-circle"
                            }}</v-icon>
                            {{ member.AadhaarVerifiedTxt }}
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- Portal Details and Aadhaar Details Cards -->
            <v-row
              v-if="Object.keys(member).length > 0 && member.MemberId"
              class="mb-5"
            >
              <!-- Left: Portal Details -->
              <v-col cols="12" md="6">
                <v-card class="portal-details-card h-100 elevation-3">
                  <v-card-title class="portal-header white--text py-3 px-4">
                    <v-icon left color="white">mdi-shield-account</v-icon>
                    Portal Details
                  </v-card-title>
                  <v-card-text class="pa-4">
                    <v-row dense>
                      <!-- Member Info Section -->
                      <v-col cols="12" sm="6">
                        <div class="field-label">
                          <v-icon x-small>mdi-identifier</v-icon>
                          Membership ID
                        </div>
                        <div class="meta-value">
                          {{ member.membership_id || "N/A" }}
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <div class="field-label">
                          <v-icon x-small>mdi-account</v-icon>
                          Name
                        </div>
                        <div class="meta-value">
                          {{ member.member_name || "N/A" }}
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <div class="field-label">
                          <v-icon x-small>mdi-briefcase</v-icon>
                          Designation
                        </div>
                        <div class="meta-value">
                          {{ member.designation || "N/A" }}
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <div class="field-label">
                          <v-icon x-small>mdi-email</v-icon>
                          Email
                        </div>
                        <div
                          class="meta-value text-truncate"
                          :title="member.email_id"
                        >
                          {{ member.email_id || "N/A" }}
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <div class="field-label">
                          <v-icon x-small>mdi-phone</v-icon>
                          Contact
                        </div>
                        <div class="meta-value">
                          {{ member.mobile_no || "N/A" }}
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <div class="field-label">
                          <v-icon x-small>mdi-calendar</v-icon>
                          DOB
                        </div>
                        <div class="meta-value">
                          {{ member.member_dob || "N/A" }}
                        </div>
                      </v-col>

                      <v-col cols="12">
                        <div class="field-label">
                          <v-icon x-small>mdi-home</v-icon>
                          Address
                        </div>
                        <div
                          class="meta-value text-truncate"
                          :title="member.address_txt"
                        >
                          {{ member.address_txt || "N/A" }}
                        </div>
                      </v-col>

                      <!-- Status Indicators -->
                      <v-col cols="12" sm="6">
                        <div class="field-label">
                          <v-icon x-small>mdi-image</v-icon>
                          Photo Update
                        </div>
                        <v-chip
                          small
                          :color="member.photo_flag ? '#10b981' : '#f59e0b'"
                          text-color="white"
                        >
                          <v-icon left x-small>
                            {{
                              member.photo_flag
                                ? "mdi-check-circle"
                                : "mdi-clock"
                            }}
                          </v-icon>
                          {{ member.photo_flag ? "Done" : "Pending" }}
                        </v-chip>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <div class="field-label">
                          <v-icon
                            x-small
                            :color="member.AadhaarNo ? '#10b981' : 'red'"
                          >
                            {{
                              member.AadhaarNo
                                ? "mdi-check-circle"
                                : "mdi-alert"
                            }}
                          </v-icon>
                          Aadhaar Verification
                        </div>
                        <v-chip
                          small
                          :color="member.AadhaarNo ? '#10b981' : '#f59e0b'"
                          text-color="white"
                        >
                          <v-icon left x-small>
                            {{
                              member.AadhaarNo
                                ? "mdi-check-circle"
                                : "mdi-alert-circle"
                            }}
                          </v-icon>
                          {{ member.AadhaarVerifiedTxt || "Not Verified" }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <!-- Right: Aadhaar Card -->
              <v-col cols="12" md="6">
                <v-card class="aadhaar-card-container elevation-3 h-100">
                  <v-card-title class="aadhaar-header white--text py-3 px-4">
                    <v-icon left color="white" size="28"
                      >mdi-account-badge</v-icon
                    >
                    Verified Aadhaar Details
                  </v-card-title>
                  <v-card-text class="pa-0">
                    <template v-if="member && member.AadhaarNo">
                      <v-card
                        elevation="0"
                        class="aadhaar-real-card mx-auto"
                        rounded="lg"
                        max-width="100%"
                      >
                        <div class="aadhaar-outer-wrapper">
                          <v-card-text class="pa-4">
                            <div class="d-flex aadhaar-content">
                              <div class="aadhaar-photo-section mr-4">
                                <v-avatar
                                  size="90"
                                  class="aadhaar-photo-container mb-3"
                                >
                                  <img
                                    v-if="member.photo"
                                    :src="member.photo"
                                    alt="Aadhaar Photo"
                                    class="aadhaar-photo"
                                  />
                                  <v-icon v-else size="50" color="#555555"
                                    >mdi-account</v-icon
                                  >
                                </v-avatar>
                              </div>
                              <div class="aadhaar-details-section flex-grow-1">
                                <div class="person-name-bilingual">
                                  <div class="name-hindi mb-1">
                                    {{ member.member_name || "NA" }}
                                  </div>
                                </div>
                                <div class="detail-row mt-2">
                                  <span class="detail-label"
                                    ><b>Date of Birth:</b></span
                                  >
                                  <span class="detail-value">{{
                                    member.member_dob || "NA"
                                  }}</span>
                                </div>
                                <div class="detail-row">
                                  <span class="detail-label"
                                    ><b>Gender:</b></span
                                  >
                                  <span class="detail-value">{{
                                    member.gender || "NA"
                                  }}</span>
                                </div>
                                <div>
                                  <span class="detail-label"
                                    ><b>Address:</b></span
                                  >
                                  <span class="detail-value address-text">{{
                                    member.address_txt || "NA"
                                  }}</span>
                                </div>
                                <div class="aadhaar-number-container mt-2">
                                  <div class="aadhaar-number-label">
                                    आधार / Aadhaar
                                  </div>
                                  <div class="aadhaar-number">
                                    <template v-if="member.AadhaarNo">
                                      <span class="aadhaar-digit-group">{{
                                        member.AadhaarNo
                                      }}</span>
                                    </template>
                                    <template v-else>XXXX XXXX XXXX</template>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="aadhaar-separator-line mt-3"></div>
                            <div
                              class="aadhaar-footer d-flex justify-space-between align-center mt-1"
                            >
                              <div class="aadhaar-issue-info caption">
                                <div class="issue-date">Issued: N/A</div>
                              </div>
                              <div class="aadhaar-tagline">
                                <span class="tagline-text-hindi"
                                  >आधार - आम आदमी का अधिकार</span
                                >
                              </div>
                              <div class="verification-badge">
                                <v-chip
                                  color="success"
                                  x-small
                                  dark
                                  class="verification-chip"
                                  ><v-icon left x-small>mdi-check-circle</v-icon
                                  >Verified</v-chip
                                >
                              </div>
                            </div>
                          </v-card-text>
                        </div>
                      </v-card>
                    </template>
                    <template v-else>
                      <v-card-text class="pa-6 aadhaar-empty">
                        <div class="empty-inner">
                          <div class="empty-icon">
                            <v-icon large color="error"
                              >mdi-alert-circle-outline</v-icon
                            >
                          </div>
                          <div class="empty-title">
                            Aadhaar details not found
                          </div>
                          <div class="empty-subtitle caption">
                            No Aadhaar record is available for this member.
                            Please request Aadhaar verification or upload the
                            Aadhaar document.
                          </div>
                        </div>
                      </v-card-text>
                    </template>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- Empty State -->
            <v-row v-else class="mt-8">
              <v-col cols="12">
                <div class="empty-state">
                  <v-icon size="64" color="primary" class="mb-3"
                    >mdi-account-search</v-icon
                  >
                  <p class="empty-text">
                    Select zone, LOM and member to view details
                  </p>
                </div>
              </v-col>
            </v-row>

            <!-- MEMBER DETAILS PREVIEW -->
            <v-row>
              <v-col cols="12">
                <v-card
                  v-if="member && Object.keys(member).length && MemberId"
                  class="member-preview elevation-3 rounded-lg"
                >
                  <!-- Professional Header -->
                  <v-card-title class="preview-header pa-4">
                    <v-icon color="white" class="mr-2">mdi-account</v-icon>
                    <span>Update Summary</span>
                  </v-card-title>

                  <v-row no-gutters>
                    <v-col
                      cols="12"
                      md="3"
                      class="d-flex align-center justify-center preview-photo"
                    >
                      <v-avatar size="120" class="elevation-6">
                        <img :src="member.photo" alt="Profile" />
                      </v-avatar>
                    </v-col>

                    <v-col cols="12" md="9">
                      <v-card-text class="preview-details pa-6">
                        <div
                          class="d-flex justify-space-between align-center mb-4"
                        >
                          <div>
                            <div class="member-name">
                              {{ member.member_name }}
                            </div>
                            <div class="member-sub">
                              <v-icon x-small class="mr-1"
                                >mdi-briefcase</v-icon
                              >
                              {{ DesignationName }}
                              <v-divider vertical class="mx-2"></v-divider>
                              <v-icon x-small class="mr-1"
                                >mdi-identifier</v-icon
                              >
                              {{ member.membership_id }}
                            </div>
                          </div>
                        </div>

                        <v-divider class="my-3"></v-divider>

                        <v-row class="mt-3">
                          <v-col cols="12" md="6">
                            <div class="meta-label">
                              <v-icon x-small class="mr-1">mdi-phone</v-icon>
                              Contact
                            </div>
                            <div class="meta-value">
                              {{ member.mobile_no || "—" }}
                            </div>
                          </v-col>

                          <v-col cols="12">
                            <div class="meta-label">
                              <v-icon x-small class="mr-1">mdi-home</v-icon>
                              Address
                            </div>
                            <div class="meta-value">
                              {{ member.address_txt || "—" }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>

                <div v-else class="empty-preview">
                  <v-row align="center" justify="center">
                    <v-col cols="12" md="8" class="text-center">
                      <v-icon color="grey" size="48">mdi-account-search</v-icon>
                      <div class="mt-3 caption">
                        No member selected. Select zone, LOM and member to load
                        details.
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-container>

          <!-- Loading Indicator -->
          <div v-if="LoadingFlag || MemberIdOptionsLoading" class="loading-overlay">
            <div class="loading-spinner">
              <v-progress-circular
                indeterminate
                color="#1976d2"
                size="60"
              ></v-progress-circular>
              <p class="loading-text">Fetching data...</p>
            </div>
          </div>
        </v-card-text>
        <div class="action-wrapper">
          <!-- Disable Reason Alert -->
          <v-alert
            v-if="
              member &&
              Object.keys(member).length > 0 &&
              (!member.AadhaarVerifiedFlag || !member.ProfileStatusFlag)
            "
            type="warning"
            dense
            text
            class="disable-reason-alert mt-3"
          >
            <div class="disable-reason-title">
              <v-icon small class="mr-1">mdi-alert-circle-outline</v-icon>
              <strong>Save button is disabled because:</strong>
            </div>
            <ul class="disable-reason-list">
              <li
                v-if="!member.AadhaarVerifiedFlag"
                class="disable-reason-item"
              >
                <v-icon x-small class="mr-1" color="error"
                  >mdi-close-circle</v-icon
                >
                <strong>Aadhaar Verification Required</strong> - Member's
                Aadhaar details must be verified
              </li>
              <li v-if="!member.ProfileStatusFlag" class="disable-reason-item">
                <v-icon x-small class="mr-1" color="error"
                  >mdi-close-circle</v-icon
                >
                <strong>Profile Status Incomplete</strong> - Member must
                complete their profile with all required documents
              </li>
            </ul>
          </v-alert>
        </div>
        <v-card-actions class="form-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="closePrompt" class="action-btn-cancel">
            <v-icon left>mdi-close</v-icon>
            Cancel
          </v-btn>
          <v-btn
            :disabled="
              !valid1 ||
              !MemberId ||
              !member.AadhaarVerifiedFlag ||
              !member.ProfileStatusFlag
            "
            color="success"
            @click.prevent="confirmAlert"
            :loading="SubmitFlag"
            class="action-btn-save"
          >
            <v-icon left>mdi-content-save</v-icon>
            Save Changes
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    editRecordPrompt: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,

      member: {},

      rows: [],
      item: {},

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      LomCodeRules: [(v) => !!v || "Lom is required"],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      ZoneCodeRules: [(v) => !!v || "Region is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      DesignationName: "",

      DesignationIdRules: [(v) => !!v || "Designation is required"],
      DesignationId: "",
      DesignationIdOptions: [],
      DesignationIdOptionsLoading: false,

      DobRules: [(v) => !!v || "Date of Birth is required"],

      AllMembers: [],

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.pageData();
      }
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
    },
    MemberIdOptions: function () {
      this.MemberIdOptionsLoading = false;
      this.MemberId = this.recordData.MemberId;
    },
    LomCodeOptions: function () {
      this.LomCodeOptionsLoading = false;
      this.LomCode = this.recordData.LomId;
    },
    ZoneCodeOptions: function () {
      this.ZoneCodeOptionsLoading = false;
      this.ZoneCode = this.recordData.ZoneId;
    },
    ZoneCode: function () {
      this.getLomCodeOptions();
    },
    LomCode: function () {
      this.getMemberIdOptions();
    },
    MemberId: function () {
      this.getMemberDetails();
    },
    DesignationIdOptions: function () {
      this.DesignationIdOptionsLoading = false;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "ngb",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      var recordData = this.recordData;
      console.log("recordData=" + JSON.stringify(recordData));
      var YearwiseOfficesHeldId = recordData.YearwiseOfficesHeldId;
      if (YearwiseOfficesHeldId != "") {
        // this.getDesignationIdOptions();
        this.getZoneCodeOptions();
        // this.MemberId = recordData.MemberId;
        this.DesignationId = recordData.DesignationId;
        this.DesignationName = recordData.DesignationName;
        // this.searchForm();
      } else {
        this.sweetAlert("error", "Designation details not fount", false);
        this.closePrompt();
      }
    },
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      //   this.$refs.ProfilePicture.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideEditRecordPrompt", this.ResultFlag);
    },
    getMemberDetails() {
      console.log("getMemberDetails called");
      this.AllMembers = [];
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        this.member = member;
        this.AllMembers.push({
          YearwiseOfficesHeldId: null,
          MemberId: member.value,
          MemberName: member.member_name,
          DesignationId: this.DesignationId,
          Designation: "",
        });
      }
    },
    getDesignationIdOptions() {
      console.log("getDesignationIdOptions called");
      this.DesignationIdOptionsLoading = true;
      var selectbox1_source = "DesignationId";
      var selectbox1_destination = "DesignationIdOptions";
      var selectbox1_url = "api/designation/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        OrganizationTypeId: 1,
        ExceptDesignationId: [1, 4, 5, 6, 7],
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getJciYearCodeOptions() {
      this.LoadingFlag = true;
      this.JciYearCodeOptionsLoading = true;
      console.log("getJciYearCodeOptions called");
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      this.LomCodeOptionsLoading = true;
      this.MemberId = "";
      this.LomCode = "";
      var selectbox1_source = "LomCode";
      var selectbox1_destination = "LomCodeOptions";
      var selectbox1_url = "api/year-wise-lom/lom-options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        YearCode: this.JciYearCode,
        ZoneCode: this.ZoneCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      this.ZoneCodeOptionsLoading = true;
      this.MemberId = "";
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/zone/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        NotAvailable: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      // this.MemberIdOptions = [];
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        LomCode: this.LomCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      // add todo in store and clear all fields in dialog
      console.log("submitForm called");

      // this.resetMessageTxt();

      var result = this.$refs.form1.validate();

      var LomCode = this.LomCode;
      var ZoneCode = this.ZoneCode;
      var MemberId = this.MemberId;
      var DesignationId = this.DesignationId;
      // var AllMembers = this.AllMembers;
      // var n1 = AllMembers.length;

      console.log(
        "LomCode=" +
          LomCode +
          ", MemberId=" +
          MemberId +
          ", DesignationId=" +
          DesignationId
      );

      if (result && LomCode != "" && MemberId != "" && DesignationId != "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/year-wise-designation/member-update";
        var upload = {
          UserInterface: 2,
          OrganizationTypeId: 1,
          YearCode: this.JciYearCode,
          LomCode: LomCode,
          ZoneCode: ZoneCode,
          MemberId: MemberId,
          DesignationId: DesignationId,
          YearwiseOfficesHeldId: this.recordData.YearwiseOfficesHeldId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.LoadingFlag = true;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        // thisIns.pageLoadingOn()

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            // thisIns.ProgessStart = 0;
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              // thisIns.SuccessMessageTxtFlag = 1;
              // thisIns.SuccessMessageTxt = output;
              thisIns.ResultFlag = true;
              thisIns.closePrompt();
              // thisIns.AllMembers = [];
              // thisIns.ResultFlag = false;
              thisIns.sweetAlert("success", output, true);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        console.log("some errors occured");
        var message = "";
        if (LomCode == "") {
          message += "LOM should not be empty. ";
        }
        if (n1 == "") {
          message += "Atleast one member is required. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss">
/* Animations */
@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes cardGlide {
  0% {
    opacity: 0;
    transform: translateY(10px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Main Container */
#preview,
.ngb-edit-wrap,
.form-card {
  border-radius: 12px;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff, #fbfdff);
  animation: fadeIn 0.4s ease-out;
}

/* Modern Professional Header */
.modify-header {
  background: linear-gradient(135deg, #05213d 0%, #1663a3 50%, #122442 100%);
  padding: 24px 28px;
  border-radius: 8px 8px 0 0;
  animation: slideInDown 0.5s ease-out;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
    height: 100%;
    background: radial-gradient(
      circle at center,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    pointer-events: none;
  }
}

.header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  position: relative;
  z-index: 1;
}

.header-left-section {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.icon-wrapper {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.05);
  }
}

.header-icon {
  font-size: 32px !important;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
}

.header-text {
  flex: 1;
}

.header-title {
  color: #ffffff;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.header-subtitle {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  font-weight: 500;
  margin: 6px 0 0 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

.header-right-section {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.year-badge {
  background: rgba(255, 255, 255, 0.25) !important;
  color: #ffffff !important;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(8px);
  transition: all 0.3s ease;
  font-weight: 600;

  &:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    transform: translateY(-2px);
  }
}

.icon-action-btn {
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.15) !important;
  position: relative;

  &:hover {
    background: rgba(255, 255, 255, 0.25) !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: scale(0.95);
  }
}

/* Section Title */
.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  border-left: 4px solid #1976d2;
  padding-left: 12px;
  animation: slideInUp 0.5s ease-out 0.1s both;
}

/* Form Fields */
.field-label {
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
}

.control-input {
  background: #fff;
  border-radius: 8px;
  animation: slideInUp 0.5s ease-out 0.15s both;

  ::v-deep .v-input__control {
    border-radius: 8px;
  }
}

/* Member Details Card */
.member-details-card {
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.06);
  animation: cardGlide 0.4s ease-out;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06), 0 2px 8px rgba(0, 0, 0, 0.04);
}

.details-card-header {
  background: linear-gradient(135deg, #05213d 0%, #1663a3 50%, #122442 100%);
  color: white;
  font-weight: 700;
  padding: 14px 16px !important;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Detail Fields */
.meta-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
  margin-bottom: 6px;
}

.meta-value {
  font-size: 14px;
  color: #111827;
  font-weight: 500;
  margin-bottom: 8px;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Empty State */
.empty-state {
  padding: 60px 20px;
  text-align: center;
  background: linear-gradient(
    135deg,
    rgba(25, 118, 210, 0.05) 0%,
    rgba(78, 142, 247, 0.05) 100%
  );
  border-radius: 12px;
  animation: slideInUp 0.5s ease-out;

  .empty-text {
    color: #6b7280;
    font-weight: 500;
    margin: 16px 0 0 0;
    font-size: 16px;
  }
}

/* Form Actions */
.form-actions {
  padding: 16px 20px;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  animation: slideInUp 0.5s ease-out 0.2s both;
}

.action-btn-cancel,
.action-btn-save {
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  font-weight: 600;
  position: relative;
  overflow: hidden;
}

.action-btn-cancel {
  color: #6b7280;
  border: 1px solid #e5e7eb;

  &:hover {
    background: #f3f4f6;
    border-color: #d1d5db;
    color: #374151;
  }
}

.action-btn-save {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }
}

.text-error {
  color: #e53935;
}

/* Member Preview Card */
.member-preview {
  margin-top: 16px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;

  &:hover {
    box-shadow: 0 12px 40px rgba(25, 118, 210, 0.15);
    border-color: #1976d2;
    transform: translateY(-4px);
  }
}

.preview-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
  color: white !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  border-bottom: 3px solid #1565c0;
}

.preview-photo {
  padding: 24px;
  background: #f8f9fa;
  border-right: 1px solid #e0e0e0;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-details {
  padding: 24px;
  background: #ffffff;
}

.member-name {
  font-size: 22px;
  font-weight: 700;
  color: #1976d2;
  letter-spacing: -0.4px;
  transition: all 0.3s ease;
  margin-bottom: 4px;
}

.member-sub {
  font-size: 13px;
  color: #6b7280;
  margin-top: 6px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
}

.preview-photo .elevation-6 {
  border: 5px solid white;
  box-shadow: 0 12px 40px rgba(25, 118, 210, 0.25) !important;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  z-index: 1;

  &:hover {
    transform: scale(1.12) rotate(2deg);
    box-shadow: 0 16px 56px rgba(25, 118, 210, 0.35) !important;
  }
}

.meta-label {
  font-size: 12px;
  color: #1976d2 !important;
  font-weight: 700 !important;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  display: flex;
  align-items: center;
}

.meta-value {
  font-size: 16px;
  color: #263238 !important;
  font-weight: 600;
  transition: all 0.3s ease;
  padding: 6px 0;
  line-height: 1.5;
}

.empty-preview {
  padding: 50px 20px;
  text-align: center;
  background: linear-gradient(
    135deg,
    rgba(25, 118, 210, 0.06) 0%,
    rgba(78, 142, 247, 0.06) 100%
  );
  border-radius: 12px;
  border: 1px dashed rgba(25, 118, 210, 0.2);
  animation: slideInUp 0.5s ease-out;
}

/* Responsive */
@media (max-width: 960px) {
  .modify-header {
    padding: 16px 18px;
  }

  .header-wrapper {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .header-right-section {
    width: 100%;
    justify-content: flex-start;
  }

  .header-title {
    font-size: 20px;
  }

  .section-title {
    font-size: 15px;
  }
}

@media (max-width: 600px) {
  .form-actions {
    flex-direction: column;
  }

  .action-btn-cancel,
  .action-btn-save {
    width: 100%;
  }

  .header-left-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

/* Loading Indicator */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(1px);
  z-index: 100;
  border-radius: 12px;
  pointer-events: none;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  animation: fadeIn 0.3s ease-out;
}

.loading-text {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  margin: 0;
  letter-spacing: 0.3px;
}
</style>
